import React from 'react';
import LogoImage from '../../../Assets/kwikmediaLogo.webp';
import {
  LegalPageRoot,
  LegalCard,
  LegalBrandRow,
  LegalLogo,
  LegalDocTitle,
  LegalDocMeta,
  LegalBody,
  LegalSectionHeading,
  LegalSubheading,
  LegalParagraph,
  LegalList,
  LegalListItem,
  LegalLink,
} from './LegalDocumentStyles';

const PrivacyPolicy = () => {
  return (
    <LegalPageRoot>
      <LegalCard>
        <LegalBrandRow>
          <LegalLogo src={LogoImage} alt="KwikMemories" />
          <LegalDocTitle>Privacy Policy</LegalDocTitle>
          <LegalDocMeta>Operated by Ventureboo LLP · KwikMemories</LegalDocMeta>
        </LegalBrandRow>

        <LegalBody>
          <LegalParagraph>
            Welcome to KwikMemories, operated by Ventureboo LLP. We are committed to protecting your
            privacy. This Privacy Policy outlines how we collect, use, and safeguard your information
            when you use our app and website.
          </LegalParagraph>

          <LegalSectionHeading>1. Information We Collect</LegalSectionHeading>

          <LegalSubheading>1.1 Personal Information</LegalSubheading>
          <LegalParagraph>
            We may collect personal information that you provide to us directly, including but not
            limited to:
          </LegalParagraph>
          <LegalList>
            <LegalListItem>Name</LegalListItem>
            <LegalListItem>Email address</LegalListItem>
            <LegalListItem>Phone number</LegalListItem>
            <LegalListItem>Payment information</LegalListItem>
            <LegalListItem>User-generated content (e.g., comments, messages)</LegalListItem>
          </LegalList>

          <LegalSubheading>1.2 Usage Data</LegalSubheading>
          <LegalParagraph>
            We collect information about your interaction with our app and website, such as:
          </LegalParagraph>
          <LegalList>
            <LegalListItem>Device information (e.g., device type, operating system)</LegalListItem>
            <LegalListItem>IP address</LegalListItem>
            <LegalListItem>Browser type and version</LegalListItem>
            <LegalListItem>Pages visited and time spent</LegalListItem>
            <LegalListItem>App usage data</LegalListItem>
          </LegalList>

          <LegalSubheading>1.3 Cookies and Tracking Technologies</LegalSubheading>
          <LegalParagraph>
            We use cookies and similar technologies to enhance your experience. You can manage
            cookie preferences through your browser settings.
          </LegalParagraph>

          <LegalSectionHeading>2. How We Use Your Information</LegalSectionHeading>
          <LegalParagraph>We use the information we collect for the following purposes:</LegalParagraph>
          <LegalList>
            <LegalListItem>To provide and maintain our services</LegalListItem>
            <LegalListItem>To process transactions and manage accounts</LegalListItem>
            <LegalListItem>To communicate with you and respond to inquiries</LegalListItem>
            <LegalListItem>
              To personalize your experience and deliver content relevant to your interests
            </LegalListItem>
            <LegalListItem>To improve our app and website functionality</LegalListItem>
            <LegalListItem>To comply with legal obligations and protect our rights</LegalListItem>
          </LegalList>

          <LegalSectionHeading>3. Sharing Your Information</LegalSectionHeading>
          <LegalParagraph>
            We do not sell or rent your personal information to third parties. We may share your
            information with:
          </LegalParagraph>
          <LegalList>
            <LegalListItem>Service providers who assist us in delivering our services</LegalListItem>
            <LegalListItem>Legal authorities if required by law or to protect our rights</LegalListItem>
            <LegalListItem>Other parties with your consent or as directed by you</LegalListItem>
          </LegalList>

          <LegalSectionHeading>4. Data Security</LegalSectionHeading>
          <LegalParagraph>
            We implement industry-standard security measures to protect your information. However, no
            method of transmission over the Internet or electronic storage is 100% secure.
          </LegalParagraph>

          <LegalSectionHeading>5. Your Rights</LegalSectionHeading>
          <LegalParagraph>You have the right to:</LegalParagraph>
          <LegalList>
            <LegalListItem>Access and update your personal information</LegalListItem>
            <LegalListItem>Request the deletion of your personal information</LegalListItem>
            <LegalListItem>Object to the processing of your personal information</LegalListItem>
            <LegalListItem>Withdraw consent at any time</LegalListItem>
          </LegalList>
          <LegalParagraph>
            To exercise these rights, please contact us at{' '}
            <LegalLink href="mailto:contact@kwikmemories.com">contact@kwikmemories.com</LegalLink>.
          </LegalParagraph>

          <LegalSectionHeading>6. Third-Party Links</LegalSectionHeading>
          <LegalParagraph>
            Our app and website may contain links to third-party websites. We are not responsible for
            the privacy practices of these websites. We encourage you to review their privacy
            policies.
          </LegalParagraph>

          <LegalSectionHeading>7. Children&apos;s Privacy</LegalSectionHeading>
          <LegalParagraph>
            Our services are not intended for individuals under the age of 13. We do not knowingly
            collect personal information from children under 13. If we become aware of any such
            data, we will take steps to delete it.
          </LegalParagraph>

          <LegalSectionHeading>8. Changes to This Privacy Policy</LegalSectionHeading>
          <LegalParagraph>
            We may update this Privacy Policy from time to time. Any changes will be posted on this
            page with an updated effective date.
          </LegalParagraph>

          <LegalSectionHeading>9. Contact Us</LegalSectionHeading>
          <LegalParagraph>
            If you have any questions or concerns about this Privacy Policy, please contact us at:
          </LegalParagraph>
          <LegalList>
            <LegalListItem>Ventureboo LLP</LegalListItem>
            <LegalListItem>
              Email:{' '}
              <LegalLink href="mailto:contact@kwikmemories.com">contact@kwikmemories.com</LegalLink>
            </LegalListItem>
            <LegalListItem>
              Phone:{' '}
              <LegalLink href="tel:+919875082248">+91 9875082248</LegalLink>
            </LegalListItem>
          </LegalList>
        </LegalBody>
      </LegalCard>
    </LegalPageRoot>
  );
};

export default PrivacyPolicy;
